import { Box } from "@mui/material"
import { isNil } from "lodash"
import { useSelector } from "react-redux"
import { AppState } from "../../core/app/AppReducer"
import { OotItemDto } from "../hints/OotItemAutocomplete"
import SphereElement from "./SphereElement"
import { SphereDto } from "./SphereTracker"

interface SphereLineProps {
    sphereLevel: number,
    onSphereItemChange: (sphereId: number, deleteSphere: boolean) => void,
    items: Array<OotItemDto | null>,
    setSphereItems: (items: Array<OotItemDto | null>, sphereLevel: number) => void
    manageChangePredecessorItem : (item: OotItemDto, sphereLevel: number, isChildReplacement?: true) => void
    isOutOfLogic?: true
}

const SphereLine = (props: SphereLineProps) => {


    let sphere = useSelector((state: AppState) => state.ui.ootr.sphere.spheres);

    const onItemChange = (item: OotItemDto | null, itemId: number) => {

        let spheresItems: SphereDto = JSON.parse(JSON.stringify(sphere[props.sphereLevel]));

        spheresItems.items[itemId] = item;
        let deleteSphere = false;

        if(isNil(item) && spheresItems.items.every(x => isNil(x)) && spheresItems.items.length === 1)
            return;

        if (isNil(item) && spheresItems.items.every(x => isNil(x)) && spheresItems.items.length <= 2)
            deleteSphere = true;

        spheresItems.items = spheresItems.items.filter(x => !isNil(x))
        
        props.setSphereItems([...spheresItems.items, null], props.sphereLevel)

        if (spheresItems.items.length === 1 || deleteSphere) {
            props.onSphereItemChange(props.sphereLevel, deleteSphere);
        }

    }

    return <Box display="flex" flexDirection="row">
        {sphere[props.sphereLevel]?.items?.map((element, i) => {
            return <SphereElement isOutOfLogic={props.isOutOfLogic} id={i} sphereLevel={props.sphereLevel} item={element} onItemChange={onItemChange} changeItemLocationOnChildChange={props.manageChangePredecessorItem} />
        })}
    </Box>
}

export default SphereLine